import React, { Component } from 'react';
import { TextField } from '@material-ui/core';

/**
 * region for hepers*/
import typing from '../../../helpers/typing';


class NotificationsFooter extends Component {
    state = {
        footer: "",
        error: false,
        validate: true
    };

    componentWillReceiveProps(nextProps) {
        this.setState({ footer: nextProps.footer, error: nextProps.error, validate: nextProps.validate });
    }

    onChange = (e) => {
        let error = false;
        if (typing.isEmpty(e.target.value) && this.state.validate) {
            error = true;
        }
        this.setState({ footer: e.target.value, error: error });
    }

    onBlur = (e) => {
        this.props.onAttributeUpdateHtml({ footer: this.state.footer }, this.state.error, e.target.id)
    }

    render() {
        const { footer, error } = this.state;
        return (
            <TextField
                label="Footer"
                id="footer"
                style={{ marginTop: 8, marginBottom: 8 }}
                placeholder=""
                fullWidth
                multiline
                rows={5}
                rowsMax={10}
                margin="normal"
                variant="outlined"
                error={error}
                value={footer}
                onBlur={this.onBlur}
                onChange={this.onChange}
                InputLabelProps={{
                    shrink: true,
                }}
            />
        )
    }
};
export default NotificationsFooter;